import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import RoutingUtil from 'src/utils/RoutingUtil';
import { customerEditAction, customerSearchAction } from './actions/CustomerActions';
import CustomerForm from './CustomerForm';
import CustomerSearch from './CustomerSearch';

const data = [
    {
        link: RoutingUtil.customerManagerUrl(),
        title: 'Manage', // tab title
        component: CustomerForm,
    },
    {
        link: RoutingUtil.customerSearch(),
        title: 'Search', // tab title
        component: () => (
            <CustomerSearch
                customerEditAction={customerEditAction}
                customerSearchAction={customerSearchAction}
                redirectUrlOnEdit={RoutingUtil.customerManagerUrl()}
                hasEdit={true}
            />
        ),
    },
];

const CustomerContainer = () => (
    <CrudLayoutContainer
        title="Customer Manager"
        tabs={data}
        routes={data}
    />
);

export default CustomerContainer;
